/**
 * @desc 查询熟料生产季度计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanQuarterClinkerResponse>> {
  return defHttp.post({
    url: '/web/plan/quarter/queryPlanClinker',
    data,
  });
}

export function mock(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<defs.PlanQuarterClinkerResponse>> {
  return defHttp.post({
    url: '/mock/web/plan/quarter/queryPlanClinker',
    data,
  });
}
